export const mutations = {
  STORE_PURCHASEORDER_ITEMS(state, purchase_order_item) {
    state.purchase_order_item = purchase_order_item;
  },
  STORE_GOODSRECEIVING(state, goodsreceiving) {
    state.goodsreceiving = goodsreceiving;
  },
  STORE_GOODSRECEIVING_UPDATE(state, id) {
    let Goodreceiving = state.goodsreceiving.find(function(goodreceiving) {
      return goodreceiving.id === id;
    });
    state.systemGoodreceiving = Goodreceiving;
  },

  STORE_GOODS_ITEMS(state, good_receiving_item){
    state.good_receiving_item = good_receiving_item
  },
  addGoodsItems(state) {
    state.goods_order_items.push({
      product_id: "",
      product_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remarks: ""
    });
  },
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/goodsreceiving/mutations.js